import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  getTrendingKeywords(filters) {
    return fetchV1.get(`/trending_keyword_tags?${toQueryString(filters)}`);
  },
  getKeywordsList(filter) {
    return fetchV1.get(`/keyword_tags?${toQueryString(filter)}`);
  },
  getCompetitorsKeywords(filters) {
    return fetchV1.get(`/competitors_keyword_tags?${toQueryString(filters)}`);
  },
  getSubscribedKeywords(filters) {
    return fetchV1.get(`/subscribed_keyword_tags?${toQueryString(filters)}`);
  },
  getBookmarkedKeywords(filters) {
    return fetchV1.get(`/bookmarked_keyword_tags?${toQueryString(filters)}`);
  },
  getBrandsKeywords(entityId, filters) {
    return fetchV1.get(`/brands/${entityId}/keyword_tags?${toQueryString(filters)}`);
  },
  getPublishersKeywords(entityId, filters) {
    return fetchV1.get(`/publishers/${entityId}/keyword_tags?${toQueryString(filters)}`);
  },
  getPartnershipKeywords(brandId, publisherId, filters) {
    return fetchV1.get(`/brands/${brandId}/publishers/${publisherId}/keyword_tags?${toQueryString(filters)}`);
  },
  getHubsKeywords(brandId, hubId, filters) {
    return fetchV1.get(`/brands/${brandId}/hubs/${hubId}/keyword_tags?${toQueryString(filters)}`);
  },
  getBrandsKeywordInsights(entityId, filters) {
    return fetchV1.get(`/brands/${entityId}/keyword_insights?${toQueryString(filters)}`);
  },
  getPublishersKeywordInsights(entityId, filters) {
    return fetchV1.get(`/publishers/${entityId}/keyword_insights?${toQueryString(filters)}`);
  },
  getPartnershipKeywordInsights(brandId, publisherId, filters) {
    return fetchV1.get(`/brands/${brandId}/publishers/${publisherId}/keyword_insights?${toQueryString(filters)}`);
  },
  getHubsKeywordInsights(brandId, hubId, filters) {
    return fetchV1.get(`/brands/${brandId}/hubs/${hubId}/keyword_insights?${toQueryString(filters)}`);
  },
};
